import { render, staticRenderFns } from "./DfrBatchUpdateModal.vue?vue&type=template&id=19ee6327"
import script from "./DfrBatchUpdateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DfrBatchUpdateModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports